import GetIconComponent from "../layout/GetIconComponent";
import { Link as RouterLink } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { MenuItemType } from "@beyondrealityapp/core/shared/types";
import { useLocation } from "react-router-dom";

const MenuItem: React.FC<MenuItemType> = ({ text, icon, path, onClose }) => {
  const location = useLocation();
  const iconComponent = GetIconComponent({ iconName: icon });
  return (
    <ListItem disablePadding>
      <ListItemButton
        component={RouterLink}
        to={path}
        onClick={onClose}
        selected={location.pathname.includes(path)}
      >
        <ListItemIcon>{iconComponent}</ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    </ListItem>
  );
};

export default MenuItem;
